import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-footer-dots",
  templateUrl: "./footer-dots.component.html",
  standalone: false,
})
export class FooterDotsComponent implements OnInit {
  constructor() {}

  ngOnInit() {}

  tabChange(tabName) {
    console.log("footer-dot tabchange", tabName);
  }
}
